import React, { useEffect, useState } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const Star = ({
  selected,
  index,
}: {
  selected: boolean;
  index: number;
}) => {
  return (
    <Svg width="39" height="35" style={styles.star}>
      <Path
        d="M38.898 13.2245C38.6412 12.485 37.9407 11.9614 37.1153 11.8914L25.8572 10.9343L21.4079 1.17925C21.0794 0.462561 20.332 0 19.5 0C18.6681 0 17.9203 0.462561 17.5939 1.17925L13.1446 10.9343L1.88471 11.8914C1.0593 11.9628 0.360358 12.4864 0.102084 13.2245C-0.154703 13.9641 0.0824451 14.7752 0.706707 15.2879L9.21696 22.2762L6.70771 32.6259C6.52413 33.3869 6.83953 34.1738 7.51378 34.6302C7.8762 34.8768 8.30199 35 8.72928 35C9.09645 35 9.46393 34.9086 9.79213 34.7247L19.5 29.2888L29.2061 34.7247C29.9182 35.1232 30.8135 35.0867 31.4863 34.6302C32.1605 34.1738 32.4759 33.3869 32.2923 32.6259L29.7831 22.2762L38.2933 15.2879C38.9173 14.7752 39.1548 13.9657 38.898 13.2245Z"
        fill={selected ? '#FFD300' : '#555555'}
      />
    </Svg>
  );
};

const STARS = Array.from({ length: 5 }, (_, index) => index + 1);

interface RatingProps {
  onSelect?: (value: number) => void;
  defaultAnswer?: {
    values: string[];
  } | null;
}

const Rating: React.FC<RatingProps> = ({onSelect, defaultAnswer = null}) => {
  const [star, setStar] = useState<number>(0);

  useEffect(()=>{
    if(defaultAnswer && defaultAnswer.values){
      let valueNum = Number.parseInt(defaultAnswer.values[0]);
      setStar(valueNum);
    }
  },[])

  return (
    <View style={styles.starContainer}>
      {STARS.map(value => {
        const handlePress = () => {
          setStar(value);
          if(onSelect){
            onSelect(value);
          }
        };
        return (
          <TouchableOpacity
            activeOpacity={1}
            key={value}
            testID={`star-${value}`}
            onPress={handlePress}
            disabled={star === value}>
            <Star selected={value <= star} index={value - 1} />
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  starContainer:{
    height:60,
    paddingTop:15,
    justifyContent:'space-between',
    alignItems:'center',
    flexDirection:'row',
    flexWrap:'wrap',
  },
  star:{

  }
})

export default Rating;
